export const checkBackendAvailability = async () => {
  const response = await fetch('');
}

export const checkConfigAvailability = async () => {
  // const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}${process.env.REACT_APP_SETUP_CONTROLLER}/?checkConfigAvailability=y`);
  // const data = await response.json();
  //
  // console.log(data)
}